import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logoHetki from "../assets/logos/Hetki-logo_black.png";
import { useLang, pick } from "../i18n/LanguageContext";
import { t } from "../i18n/translations";

// Hetki Company -puolen sivut. Vain näillä näytetään sivulinkit: portti on
// valintasivu ja /film on oma puolensa, joten niillä on pelkkä kielivalitsin.
const HETKI_PAGES = ["/hetki", "/tyot", "/palvelut", "/yhteys"];

const Navbar = () => {
  const { lang, setLang } = useLang();
  const tr = pick(lang);
  // Portilla ja /hetki-heron videon päällä vaalea navi, muilla tumma.
  // Film-sivulla koko ruudun hero omistaa yläreunan: kielivalitsin
  // pudotetaan vasta heron jälkeisen osion yläreunaan.
  const { pathname } = useLocation();
  const isGateway = pathname === "/";
  const isHetkiHome = pathname === "/hetki";
  const isHetkiSide = HETKI_PAGES.includes(pathname);
  const belowHero = pathname === "/film";
  const pages = [
    { to: "/tyot", label: t.nav.work },
    { to: "/palvelut", label: t.nav.services },
    { to: "/yhteys", label: t.nav.contact },
  ];

  // nav--pages: sivulinkit mukana, joten kapeilla ruuduilla navia tiivistetään.
  const className = [
    "nav",
    !isGateway && !isHetkiHome && "nav--dark",
    isHetkiHome && "nav--over-video",
    isHetkiSide && "nav--pages",
    belowHero && "nav--below-hero",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={className}>
      <nav className="nav__inner" aria-label={tr(t.nav.main)}>
        {/* Hero-video sisältää brändin visuaalisen identiteetin, joten
            /hetki-sivulla logoa ei näytetä, ettei se peitä videota. Muilla
            Hetki-puolen sivuilla pieni HETKI-logo vie takaisin /hetki-sivulle. */}
        {isHetkiSide && !isHetkiHome ? (
          <Link to="/hetki" className="nav__brand" aria-label={tr(t.nav.home)}>
            <img src={logoHetki} alt="" width="1459" height="698" />
          </Link>
        ) : (
          <span className="nav__brand nav__brand--placeholder" aria-hidden="true" />
        )}

        <div className="nav__end">
          {isHetkiSide && (
            <ul className="nav__list">
              {pages.map((p) => (
                <li key={p.to}>
                  <NavLink
                    to={p.to}
                    className={({ isActive }) =>
                      `nav__link${isActive ? " is-active" : ""}`
                    }
                  >
                    {tr(p.label)}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}

          <div className="nav__lang" role="group" aria-label={tr(t.nav.language)}>
            <button
              type="button"
              className={`nav__lang-btn${lang === "fi" ? " is-active" : ""}`}
              onClick={() => setLang("fi")}
              aria-pressed={lang === "fi"}
            >
              FI
            </button>
            <span className="nav__lang-sep" aria-hidden="true">·</span>
            <button
              type="button"
              className={`nav__lang-btn${lang === "en" ? " is-active" : ""}`}
              onClick={() => setLang("en")}
              aria-pressed={lang === "en"}
            >
              EN
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
